module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"conversionName":"Conversion name","conversionParameter":"Conversion parameters"},"ja":{"conversionName":"コンバージョン名","conversionParameter":"コンバージョンパラメータ"},"zh-hant":{"conversionName":"轉換名","conversionParameter":"轉換參數"},"zh-hans":{"conversionName":"转换名","conversionParameter":"转换参数"}}')
  delete Component.options._Ctor
}
